import { LOCAL_STORAGE_NAME } from "@/constants/global";

export default {
  get: function (username: string) {
    const trustedToken = JSON.parse(
      localStorage.getItem(LOCAL_STORAGE_NAME.TRUSTED_2FA_EMAIL_DEVICE_TOKEN) || "{}"
    ) as Record<string, string>;

    return trustedToken[username];
  },
  set: function (username: string, token: string) {
    const trustedToken = JSON.parse(
      localStorage.getItem(LOCAL_STORAGE_NAME.TRUSTED_2FA_EMAIL_DEVICE_TOKEN) || "{}"
    ) as Record<string, string>;
    trustedToken[username] = token;
    localStorage.setItem(LOCAL_STORAGE_NAME.TRUSTED_2FA_EMAIL_DEVICE_TOKEN, JSON.stringify(trustedToken));
  },
  delete: function (username: string) {
    const trustedToken = JSON.parse(
      localStorage.getItem(LOCAL_STORAGE_NAME.TRUSTED_2FA_EMAIL_DEVICE_TOKEN) || "{}"
    ) as Record<string, string>;
    delete trustedToken[username];
    localStorage.setItem(LOCAL_STORAGE_NAME.TRUSTED_2FA_EMAIL_DEVICE_TOKEN, JSON.stringify(trustedToken));
  },
};
